// @flow
import { RouterSelectors } from '@zapier/toolbox-redux-framework';

export const isOnSharedZapRoute = (state: Object) => {
  return RouterSelectors.getCurrentPathname(state).includes('/shared/');
};

export const isOnSharedZapPOC = (state: Object) => {
  return (
    isOnSharedZapRoute(state) && !!RouterSelectors.getQueryParam(state, 'conv')
  );
};
